
export const siteData = {
  hero: {
    title: "الركن الملكي.. ركيزتكم الأولى للكوادر المحترفة",
    description: "نحن شركة رائدة في توفير العمالة المصرية للمملكة العربية السعودية و دول الخليج، نعمل بترخيص رسمي رقم (1415) من وزارة القوى العاملة المصرية.",
    highlights: [
      {
        id: "vision",
        title: "رؤيتنا",
        content: "الإيمان بأن نجاح أي مؤسسة يبدأ من اختيار الفريق المناسب.",
      
      },
      {
        id: "mission",
        title: "رسالتنا",
        content: "تقديم خدمات توظيف موثوقة وسريعة تلبي احتياجات مختلف القطاعات بمهنية عالية.",
   
      },
      {
        id: "commitment",
        title: "التزامنا",
        content: "نضمن الدقة، المصداقية، وتسهيل كافة الإجراءات حتى استلام العمالة.",
     
      }
    ]
  },
  services: [
    {
      id: 1,
      title: "خدمة الاستقدام",
      target_audience: "الشركات والمؤسسات والأفراد",
      description: "نوفّر للشركات والمؤسسات والأفراد في  المملكة العربية السعودية و دول الخليج أفضل العمالة المصرية المحترفة من خلال شركتنا الركن الملكي، مع الالتزام الكامل بمعايير الجودة والسرعة.",
      features: [
        "توفير عمالة مصرية مؤهلة وذات خبرة في جميع التخصصات",
        "تسهيل كافة إجراءات السفر والتأشيرات بسرعة واحترافية",
        "متابعة كاملة حتى وصول العامل لمكان العمل واستلامه مهامه",
        "عقود رسمية وملتزمة بالقوانين السعودية"
      ],
      contact_number: "01068888945"
    },
    {
      id: 2,
      title: "خدمة التوظيف",
      target_audience: "للمصريين فقط",
      description: "نحرص على تقديم فرص عمل حقيقية ومميزة للمصريين في المملكة العربية السعودية و دول الخليج، من خلال شركتنا الركن الملكي مع الاهتمام الكامل بحقوقهم.",
      features: [
        "توفير فرص عمل متوافقة مع خبرتك ومهاراتك",
        "رواتب عادلة ومنافسة",
        "عقود رسمية مضمونة تحمي حقوقك",
        "متابعة ودعم مستمر حتى بعد وصولك لمكان العمل",
        "مساعدة في استخراج الأوراق والتأشيرات المطلوبة بسرعة وسهولة"
      ],
      contact_number: "01095555907"
    },
    {
      id: 3,
      title: "خدمة التعقيب",
      description: "نوفر لك خدمة تعقيب شاملة لضمان سرعة، وكفاءة إنهاء جميع الإجراءات قبل السفر للعمل في المملكة العربية السعودية و دول الخليج.",
      features: [
        "متابعة استخراج التأشيرة والفحص الطبي والبصمة",
        "تجهيز جميع العقود والمستندات الرسمية المطلوبة",
        "متابعة الإجراءات خطوة بخطوة حتى اكتمال كل الأوراق",
        "دعم مستمر وإرشادات قبل السفر لضمان راحتك",
        "توفير وقتك وجهدك وتسهيل كل التعقيدات الورقية"
      ],
      contact_number: "01050559173"
    },
    {
      id: 4,
      title: "خدمة التوثيق",
      description: "نوفر في الركن الملكي خدمة توثيق جميع الأوراق والمستندات المطلوبة للسفر والعمل  في المملكة العربية السعودية و دول الخليج.",
      features: [
        "توثيق عقود العمل",
        "توثيق الشهادات الدراسية والمهنية",
        "توثيق شهادات الميلاد",
        "توثيق شهادات الخبرة",
        "توثيق السجلات التجارية",
        "توثيق المستندات الرسمية الأخرى",
        "سرعة في إنهاء التوثيق",
        "مراجعة دقيقة لجميع الأوراق",
        "ضمان قبول المستندات لدى الجهات المختصة"
      ],
      contact_number: "01050559173"
    }
  ],
  faqs: [
    {
      question: "ما هي الخدمات التي تقدمها شركة الركن الملكي؟",
      answer: "نقدم خدمات (استقدام العمالة –  التوظيف بالخارج - التعقيب -جميع التوثيقات من الجهات المعتمدة) بالإضافة إلى متابعة الطلبات وتوفير الدعم الكامل للعملاء."
    },
    {
      question: "هل الشركة مرخصة؟",
      answer: "نعم، شركة الركن الملكي تعمل بترخيص رسمي رقم (1415) لدى وزارة القوى العاملة المصرية، ونلتزم بجميع الضوابط والقوانين."
    },
    {
      question: "ما هي التخصصات التي توفرونها؟",
      answer: "نوفر كوادر مصرية مؤهلة لسوق العمل الخارجي، بما في ذلك: الأطباء - التمريض - المهندسين - المحاسبين - المحاميين - التسويق - العمالة الفنية – السائقين – الضيافة – عمال المصانع – العمالة المدربة للورش والمواقع."
    },
    {
      question: "كم تستغرق مدة إنهاء إجراءات السفر والتعاقد؟",
      answer: "تعتمد على التخصص والمتطلبات، لكن غالبًا تتراوح المدة بين 10 إلى 30 يومًا، مع متابعة يومية حتى موعد السفر."
    },
    {
      question: "هل يمكن متابعة حالة الطلب؟",
      answer: "نعم، نتيح للعميل متابعة حالة الطلب من خلال خانة تتبع الطلب في موقعنا."
    },
    {
      question: "هل توفرون عقود رسمية ومضمونة؟",
      answer: "نعم، جميع العقود تتم وفق القوانين المعتمدة في دول الخليج والمعتمدة من وزارة العمل المصرية، مع توثيق كامل وضمان حقوق الطرفين."
    },
    {
      question: "كيف يتم التواصل ومتابعة حالة الطلب؟",
      answer: "نوفر قنوات تواصل مباشرة عبر: الهاتف – الواتساب – الإيميل – فريق عمل متخصص لضمان سرعة الرد."
    }
  ],
  clients: [
    { name: "قطوف وحلا", logo: "/assets/clients/qotouf.png" },
    { name: "كنافة تايم", logo: "/assets/clients/kunafa-time.png" },
    { name: "حلويات سعد الدين", logo: "/assets/clients/saad-eldin.svg" },
    { name: "مؤسسة ركائز الشرق الأول للمقاولات", logo: "/assets/clients/rakaez.jpg" },
    { name: "مجموعة خالد صالح الحناكي للتجارة", logo: "/assets/clients/al-hanaki.jpeg" },
    { name: "شركة مباني الجزيرة العربية للتجارة", logo: "/assets/clients/mabani.jpeg" },
    { name: "شركة تكنو هاوس للصناعة", logo: "/assets/clients/techno-house.jpg" },
    { name: "مؤسسة سواتر الحماية للحراسات الأمنية", logo: "/assets/clients/swater.png" },
    { name: "مكتب نايف فيصل البصيص للمحاماة", logo: "/assets/clients/naif-law.png" },
    { name: "شركة محمد هادي الرشيد وشركاه", logo: "/assets/clients/al-rasheed.png" },
    { name: "شركة العراب المتحدة للاستثمار", logo: "/assets/clients/al-arrab.jpeg" },
    { name: "شركة بارزان للاستشارات الهندسية", logo: "/assets/clients/barzan.avif" },
    { name: "مجموعة وضوح الرؤية", logo: "/assets/clients/wodooh.avif" },
  ],
  testimonials: [
    {
      name: "Ahmed Sied",
      content: "أفضل الشركات احترام دقة مصداقية في العمل. طاقم العمل مثال مشرف للشركه مهما كتبت وتحدثت لايكفي حديثي في حق الشركة كل الشكر لكل من يعمل تحت راية شركة الركن الملكي ارقي تعامل ويد امينة بكل معني. شكرا لكل موظف داخل الشركه وفروعها أنتم مثال مشرف لشركات الحاق العمالة بالخارج. لا يكفي الحديث عنكم شكرا جدا لذوق حضراتكم حفظكم اللّٰه",
      role: "عميل"
    },
    {
      name: "Mohamed Alaa",
      content: "حقيقي من افضل الشركات في اقل من ١٥ يوم بالفعل كل الاجراءات كانت خلصت بتمني لكن دوام التوفيق و النجاح حقيقي متشكر جدا جدا ليكم بجد كنتم جمبي خطوه بخطوه 🥰❤️❤️❤️🫱🏻‍🫲🏼",
      role: "عميل"
    },
    {
      name: "bedair eldeeb",
      content: "محترمين جدا و ما بيا خدوش وقت من أفضل الشركات إللي ممكن تتعامل معاها مصداقيه وأمانه ومعامله محترمة بصراحه ربنا يوفقهم دائما لكل خير",
      role: "عميل"
    },
    {
      name: "amr fayez",
      content: "الحمد لله ربنا وفقني في شغل في السعوديه من خلالهم و من أكتر الشركات إحترافية و إحترام و مصداقيه و همهم الأول مصلحة العميل و جاهزين دايما للرد على أي إستفسار في أي وقت فعلا من الناس المحترمه جدا و بالأخص أستاذ فتحي المدير التنفيذي للشركه و أستاذه سلمى مسئولة المتابعه في الشركه ❤️ بالتوفيق دايما ان شاء الله",
      role: "عميل"
    },
    {
      name: "Walid Elshenawi",
      content: "شهاده بيني وبين ربنا انا اعرف المكتب ده من ٢٠١٩والله ماقابلني حد في الامانه دي والمصدقيه دي دا حتي بعد ما سافرت احتاجت منهم مساعده متاخروش عليا وعملو معايا الي هما مش ملزمين بيه اصلا وربنا وحده شاهد علي كلامي ده",
      role: "عميل"
    },
    {
      name: "Farouk Eleraky",
      content: "افضل اختيار بصراحه انا كنت مطمن من اول يوم روحت فيه المكتب اتعاملت مع موظفين احترام وخبرة ومنظمين جدا والمواعيد مظبوطه وكان عندي رفض طبي وقفوا معايا لحد ما مشكلتي اتحلت بفضل ربنا والحمد لله التأشيرة طلعت الركن الملكي الاختيار الافضل ثقة وخبرة واحترام و التزام و كفاءة عالية اتمني لهم التوفيق والنجاح الدائم",
      role: "عميل"
    },
    {
      name: "Sona Son22",
      content: "انا اسمي حسن مدخلتش الشركه دي كل تعاملاتي بالتليفون ومحصليش الشرف للأسف اني اسافر من خلالهم لأول مره اتعامل مع ناس قمه في الرقي مدير المكتب ابو الياس ايه الزوق والاحترام والتواضع ده وابو مالك كلمته مره واحده بس قمه في الاحترام واستاذه نورا تعبتها جدا معايا وكانت صبوره لاقصي درجه الناس دي مش بتاخد فلوس علشان تطلعك وخلاص الناس دي بيتكلموا معاك على انك حد منهم دفعت مبلغ بسيط جدا علشان حجوزات البصمه بمجرد اني كنسلت السفر لقيت فلوس بتتحول زي ما بعتها والله على ما أقول شهيد ربنا يراضيهم يارب",
      role: "عميل"
    },
    {
      name: "محمد على",
      content: "من أفضل الشركات احترام دقة مصداقية في العمل. طاقم العمل مثال مشرف للشركه مهما كتبت وتحدثت لا يفئ حديثي حق الشركة كل الشكر لكل من يعمل تحت راية شركة الركن الملكي ارقي تعامل ويد امينة بكل معني. شكرا أستاذ سعد أنتم مثال مشرف لشركات الحاق العمالة بالخارج. لا يفئ الحديث حقكم شكرا جدا لذوق حضراتكم حفظكم الله",
      role: "عميل"
    },
    {
      name: "فرج الامير البيومى",
      content: "الأحترام والتقدير خدمات ممتازة غير المعامله بكل احترام وتقدير والكل معاك لحظة بلحظة شركة فوق الممتاز ربنا يبارك فيهم",
      role: "عميل"
    },
    {
      name: "karim gamee",
      content: "تعامل محترم وشركة وكويسه جدآ ومهتمين جدآ بعملائهم ومعاك خطوه بخطوه ومساعدين جدآ",
      role: "عميل"
    },
    {
      name: "Omar Asran",
      content: "اتعاملت معاهم مرتين في انهاء اجراءات تأشيرة عمل للسفر للسعودية وحقيقي الشركة بموظفيها قمة في الاحترام والمصداقية في التعامل وسرعة انهاء الاجراءات في اقل من ١٥ يوم وردهم دايما علي اي استفسارات وابلاغهم للعميل دايما بالمستجدات وحسن ضيافتهم للعميل بالشركة بشكرهم جدا...بالتوفيق لهم دائما وجزاهم الله عنا كل خير",
      role: "عميل"
    },
    {
      name: "محمد رجب محجوب",
      content: "كل الأحترام والتقدير خدمات ممتازة غير المعامله بكل احترام وتقدير والكل معاك لحظة بلحظة شركة فوق الممتاز ربنا يبارك فيهم",
      role: "عميل"
    },
    {
      name: "HiMoO KaDoUs هيمو قدوس",
      content: "بصراحة المعامله محارمه جدا والناس صبرت كتير عليا والحمد لله من كرمه وفضله وصلنا لكل شئ يرضيني ولاخر الوقت واقفين جمبي ربنا يبارك فييكم موفقين دائما ان شاء الله",
      role: "عميل"
    },
    {
      name: "Mohamed El-hdad",
      content: "الشهاده لله حضرتك وكل تيم الشركه ناس محترمين جدا وصادقين في كلامكم مافيش كلمه حضرتك قولتهالي ف المكتب ولقيت عكسها هنا كل الاتفاقات اتنفذت بالحرف",
      role: "عميل"
    },
    {
      name: "Ahmed Emad",
      content: "بصراحه ناس محترمه انا مسافر السعوديه عن طريق المكتب دا بصراحه حاجه محترمه والناس اخلاقها تمام والاستقبال ممتاز والموضوع مخدش 14 يوم وكنت مسافر والعقد الي روحت علي لقيته بالظبط فا دي شهاده لله وشكرا خاص لموظفه الاستقبال حاجه محترمه لمه كنت بحتاج حاجه كانت بترد علطول ومحدش قصر شكر جزيلا الركن الملكي",
      role: "عميل"
    },
    {
      name: "محمد كمال",
      content: "روحت أماكن كتير بس مفيش مكان فيه راحه وتقدير واهتمام بالمتقدمين للعمل غير عندكم من اول بنت الي بتضحك وتعزم علينا بقهوه والواحد جاي متوتر اصلا من المقابله الي البنت موظفه الاستقبال وحسن تعاونها معانا الي استاذنا ابو الياس الراجل الجدع والاخ لينا من كلامه ومعاملته مع الناس ربنا يبارك فيه ويوسع في رزقه كنت مبسوط جدًا يوم المقابلة، حسيت إني بين ناس محترمة وجدعان بجد تحية كبيرة للمدير أبو إلياس على حسن الاستقبال والكلمة الطيبة، وربنا يجازيكم كل خير ويوفقكم دايما . ربنا يبارك فيكم وفي شغلكم، ويسهلكم كل طريق أخوكم محمد كمال محمد واتمني ان اسافر معاكم والله واكون واحد منكم",
      role: "عميل"
    },
    {
      name: "محمد علي",
      content: "مهما كتبت وتحدثت لا يفئ حديثي حقكم كل الشكر لكل من يعمل تحت راية شركة الركن الملكي ارقي تعامل ويد امينة بكل معني. شكرا أنتم مثال مشرف لشركات الحاق العمالة بالخارج. شكرا جدا لذوق حضراتكم حفظكم الله",
      role: "عميل"
    },
    {
      name: "محمد سعيد",
      content: "بجد انا بشكر مكتب الركن الملكي علي حسن التعامل والمصدقيه كانت تجربه ممتازه وكان احسن اختیار وبشكر استاذ سعد سلام علي حسن التعامل وبشكر استاذه سلمي عبد القادر علي حسن تعاملها وبشكر مكتب الركن الملكي جميعا وانا تقييمي ليهم 10 من 10 وديما يارب موفقين ونجحيين في عمالكم وبالتوفيق ان شاء الله ومن نجاح لنجااح وشكرا مع تحيات.... محمد سعید منصور",
      role: "عميل"
    },
    {
      name: "Ahmed abd elaty el noby",
      content: "شركه الركن الملكي عن تجربه شخصيه من اصدق وانضف شركات الحاق العماله التيم كله محترم ومتعاون لابعد الحدد كانو معايا خطوه بخطوه لحد م استلمت الجواز متأشر الحمد لله عشان كدا لو عاوز المفيد خليك مع الركن الملكي اكيد",
      role: "عميل"
    },
    {
      name: "Sohaila Waheid",
      content: "ناس محترمين جدا واستقبال محترم ن أفضل الشركات إللي ممكن تتعامل معاها مصداقيه وأمانه ومعامله محترمة وخدمات فوق الممتازه بصراحه شفافيه كامله في التعامل ربنا ييسر لهم أمورهم ويوفقهم دائما لكل خير ويسدد خطاهم",
      role: "عميل"
    },
    {
      name: "يقين",
      content: "من أحسن الشركات الـ الإنسان بيتعامل معاهم أخت صاحبتي بتشكر فيها جدا وطبعاً بناخد برأي المقربين لينا فـ بنجرب زيهم وناس محترمين وذوق والتعامل معاهم جميل جداً ربنا يبارك فيهم ودايما فـ تقدم، ربنا ينفع بيهم ويبارك فيهم كل القائمين عـ المؤسسة ناس محترمه وخدومه جدا وبيتعاملوا بذوق جدا ♥️",
      role: "عميل"
    },
    {
      name: "Hamada Elzyat",
      content: "من أفضل الشركات إللي ممكن تتعامل معاها مصداقيه وأمانه ومعامله محترمة وخدمات فوق الممتازه بصراحه شفافيه كامله في التعامل بيوضحولك كل شيء ولو يقدروا يساعدوا بأي خدمة تسهل عليك بيعملوا كده حتى لو مش هياخدوا مقابل عليها المهم المصلحة العامة بيحاولو بشتى الطرق ييسروا عليك مشوارك عن تجربه شخصيه وعن تجارب ناس كتير أعرفهم ربنا ييسر لهم أمورهم زي ما بييسروا على الناس ويوفقهم دائما لكل خير ويسدد خطاهم",
      role: "عميل"
    },
    {
      name: "Ahmed Soltan",
      content: "مكتب ثقه واحسن معامله ولما تدخل المكتب خلاص كده انت بقيت واحد من العيله ناس في قمة الاحترام ابو إلياس ربي يسعدك ويجعل دنيتك واخرتك كلها خير وسعاده",
      role: "عميل"
    }
  ],
  contact: {
    email: "rokn.malaky@gmail.com",
    phone: "233351366",
    social_media: [
      { platform: "facebook", url: "https://www.facebook.com/royal.corner1415" },
      { platform: "instagram", url: "https://www.instagram.com/royalcorner23" },
      { platform: "tiktok", url: "https://www.tiktok.com/@elrokn.elmalaky" },
      { platform: "snapchat", url: "https://www.snapchat.com/@elroknelmalky" },
      { platform: "telegram", url: "https://t.me/RoyalCorne" }
    ]
  }
};
